module.exports = __webpack_public_path__ + "img/cloud-download-alt.df2f70bf.svg";